import { Link } from "react-router-dom";
import { trackEvent } from "../../../utils/analytics";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-teal-50 py-6 px-4 sm:px-6 lg:px-8 border-t border-teal-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <Link to="/" className="flex items-center" onClick={() => trackEvent('nav_link_clicked', { location: 'footer', label: 'logo_home' })}>
            <img
              src="/RoamMyWay.png"
              alt="RoamMyWay"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <nav className="flex items-center gap-6">
            <Link to="/privacy" className="text-gray-600 hover:text-teal-600 text-xs sm:text-sm transition-colors" onClick={() => trackEvent('nav_link_clicked', { location: 'footer', label: 'privacy_policy' })}>
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-teal-600 text-xs sm:text-sm transition-colors" onClick={() => trackEvent('nav_link_clicked', { location: 'footer', label: 'terms_of_service' })}>
              Terms of Service
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-teal-600 text-xs sm:text-sm transition-colors" onClick={() => trackEvent('nav_link_clicked', { location: 'footer', label: 'contact' })}>
              Contact
            </Link>
          </nav>

          <p className="text-gray-500 text-xs sm:text-sm">
            © {currentYear} RoamMyWay. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
